import { SignalRBridge } from '@/utils/signalRBridge';

export enum SignalRConnectionState {
  DISCONNECTED = 'Disconnected',
  CONNECTING = 'Connecting',
  CONNECTED = 'Connected',
  DISCONNECTING = 'Disconnecting',
  RECONNECTING = 'Reconnecting',
}

export interface SignalRState {
  bridge: SignalRBridge | null;
  connectionState: SignalRConnectionState;
  isConnecting: boolean;
  isConnected: boolean;
  error: string | null;
  url: string | null;
  reconnectAttempts: number;
  maxReconnectAttempts: number;
  groupName: string | null;
}

export interface SignalRActions {
  connect: (url: string, location: string, groupName: string) => Promise<void>;
  disconnect: () => Promise<void>;
  invokeMethod: (methodName: string, ...args: unknown[]) => Promise<void>;
  subscribe: (
    methodName: string,
    callback: (...args: unknown[]) => void,
  ) => void;
  unsubscribe: (
    methodName: string,
    callback?: (...args: unknown[]) => void,
  ) => void;
  setError: (error: string | null) => void;
  clearError: () => void;
  resetReconnectAttempts: () => void;
}

export interface SignalRStore extends SignalRState {
  actions: SignalRActions;
  // Helper functions for state checks
  isConnectionActive: () => boolean;
  canReconnect: () => boolean;
}
